(() => {
  class ArtworkAccount {
    constructor(uploader) {
      this.u = uploader;
      this.endpoint = (uploader.root.dataset.accountEndpoint || '').replace(/\/+$/, '');
      this.generation = 0;
    }
    reset() { this.generation++; }
    async request(path, body) {
      const response = await fetch(this.endpoint + path, {
        method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
        ...(body ? {headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body)} : {}),
      });
      if (!response.ok) throw new Error('Account association unavailable');
      return response.json();
    }
    async uploaded(result) {
      if (!this.endpoint || this.u.cloudUploadState !== 'ready') return false;
      const generation = this.generation;
      try {
        const session = await this.request('/session');
        if (!session.authenticated || generation !== this.generation) return false;
        await this.request('/artworks', {
          artworkId: result.artworkId || result.uploadId, versionId: result.versionId,
          completionToken: result.completionToken, sessionId: this.u.browserSessionId,
        });
        return true;
      } catch { return false; }
    }
  }
  window.InkArtworkAccount = ArtworkAccount;
})();
